import { Stack } from "@mui/material";
import TextInput from "../../../components/files/TextInput";
import { celIsraeli } from "../../../utils/validations";
import SelectInput from "../../../components/files/SelectInput";
import { useBizType } from "hooks/useBizType";
import { BIZ_TYPE, COLORS } from "config/const";
import SelectColorPicker from "components/files/SelectColorPicker";

const ClientDetails = ({ errors, control, clientList }) => {
  const { bizTypeCheck } = useBizType()

  return (
    <Stack spacing={2}>
      <SelectInput
        width="100%"
        errors={errors}
        required
        options={clientList}
        name="clientId"
        title={"SELECT_CLIENT"}
        control={control}
      />

      <Stack direction="row" spacing={2}>
        <TextInput
          width={{ xs: "100%", md: "auto" }}
          addFlex
          required
          errors={errors}
          validation={celIsraeli}
          name="tel"
          title="TEL"
          control={control}
        />

        <TextInput
          width={{ xs: "100%", md: "auto" }}
          required
          addFlex
          errors={errors}
          name="name"
          title="CONTACT_NAME"
          control={control}
        />
      </Stack>

      <Stack direction="row" spacing={2}>

        {bizTypeCheck(BIZ_TYPE.SERVICE_PROVIDER)
          ? <TextInput
            width={{ xs: "100%", md: "auto" }}
            addFlex
            errors={errors}
            name="clientCallId"
            title="CLIENT_CALL_ID"
            control={control}
          />
          : null
        }

        <TextInput
          width={{ xs: "100%", md: "auto" }}
          addFlex
          errors={errors}
          name="addr"
          title="ADDR"
          control={control}
        />

        <SelectColorPicker
          name="color"
          title="COLOR"
          width={{ xs: 90, md: 220 }}
          addFlex
          colors={COLORS}
          errors={errors}
          control={control}
        />
      </Stack>
    </Stack>
  );
};
export default ClientDetails;
